import { DefaultService } from "@/services/DefaultService";
import API from "@/plugins/axios";

class CambioPropietarioService extends DefaultService {
  
  constructor() {
    super('cambioPropietario');
  }

  getDataDomicilio(establecimiento: any): Promise<any>{
    return API.get(`cambioPropietario/getDataDomicilio/${establecimiento}`);
  }

  getSolicitudesCambioPropietario(establecimiento: any): Promise<any>{
    return API.get(`cambioPropietario/getSolicitudesCambioPropietario/${establecimiento}`);
  }

  setSolicitudCambioPropietario(establecimiento: any, data: any): Promise<any>{
    return API.post(`cambioPropietario/setSolicitudCambioPropietario/${establecimiento}`, data);
  }

  getSolicitudCambioPropietario(establecimiento: any, solicitud: any): Promise<any>{
    return API.get(`cambioPropietario/getSolicitudCambioPropietario/${establecimiento}/${solicitud}`);
  }

  changeStatusSolicitudCambioPropietario(establecimiento: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioPropietario/changeStatusSolicitudCambioPropietario/${establecimiento}/${solicitud}`, data);
  }

  updateSolicitudCambioPropietario(establecimiento: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioPropietario/updateSolicitudCambioPropietario/${establecimiento}/${solicitud}`, data);
  }

  storeFiles(establecimiento: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioPropietario/storeFiles/${establecimiento}/${solicitud}`, data);
  }

  deleteSolicitudCambioPropietario(establecimiento: any, solicitud: any, data: any): Promise<any>{
    return API.post(`cambioPropietario/deleteSolicitudCambioPropietario/${establecimiento}/${solicitud}`, data);
  }
}

export default new CambioPropietarioService;